export default {
  'userDevices.title': 'Devices',
  'userDevices.user': 'User',
  'userDevices.statusColumn': 'Status',
  'userDevices.status.enabled': 'Enabled',
  'userDevices.status.disabled': 'Disabled',
  'userDevices.lastLogin': 'Last access',
  'userDevices.name': 'Name',
  'userDevices.platform': 'Platform',
  'userDevices.country': 'Country',
  'userDevices.application': 'Application',
  'userDevices.region': 'Region',
  'userDevices.state': 'State / Province',
  'userDevices.userAgent': 'Agent',
  'userDevices.action.lock': 'Lock',
  'userDevices.action.unlock': 'Unlock',

  'userDevices.platformType.unknown': 'Unknown',
  'userDevices.platformType.generic': 'Generic',
  'userDevices.platformType.windows': 'Windows',
  'userDevices.platformType.linux': 'Linux',
  'userDevices.platformType.unix': 'Unix',
  'userDevices.platformType.ios': 'Apple iOS',
  'userDevices.platformType.macOs': 'macOS',
  'userDevices.platformType.blackBerry': 'BlackBerry',
  'userDevices.platformType.android': 'Android',
  'userDevices.platformType.symbian': 'Symbian',
};
